import gql from 'graphql-tag'

const OfferResultFragment = gql`
  fragment dooerComPreOfferResult on AccountingOnboardingSyncedPreOfferResult {
    status
    estimatedMonthlyPriceAmount
    estimatedMonthlyPriceCurrency
    rejectionReasons
    syncedByFirstName
    syncedByLastName
    ownerEmail
    syncedCompanyInfo {
      propertyMessage
      propertyValue
    }
    syncedBankInfo {
      propertyMessage
      propertyValue
    }
    syncSessionId
  }
`

export const preOfferQuery = gql`
  query DooerComPreOfferQuery($organizationId: ID!) {
    organization(id: $organizationId) {
      id
      name
      owner {
        id
        firstName
        lastName
        sePersonnummer
        email
      }
      accountingOnboardingSyncedPreOffer {
        id
        idNumber
        organizationNumber
        ...dooerComPreOfferResult
      }
    }
  }

  ${OfferResultFragment}
`

export const preOfferMutation = gql`
  mutation DooerComPreOfferMutation(
    $organizationId: ID!
    $status: AccountingOnboardingSyncedPreOfferStatus!
    $businessInfo: JSON
  ) {
    organization(id: $organizationId) {
      accountingOnboardingSyncedPreOffer {
        changeStatus(status: $status, businessInfo: $businessInfo)
      }
    }
  }
`

export const preOfferSubscription = gql`
  subscription SumifyAccountingOnboardingSyncedPreOfferSubscription($id: ID!, $filter: String) {
    preOfferStateChanged(id: $id) {
      id

      organization {
        id

        subscriptionOffers(first: -1, filter: $filter) {
          edges {
            node {
              id
              feeExVat
            }
          }
        }
      }
    }
  }
`

export const ordersMutation = gql`
  mutation DooerComOrdersMutation($input: OrderInput!) {
    orders {
      create(input: $input) {
        contact {
          name
        }
      }
    }
  }
`

export const accountingOnboardingMutation = gql`
  mutation DooerComAccountingOnboardingMutation($id: ID!, $input: AccountingOnboardingInput!) {
    organization(id: $id) {
      accountingOnboarding {
        setAccountingOnboarding(input: $input) {
          id
        }
      }
    }
  }
`

export interface ICompanyProps {
  name: string
  organizationNumber: string
  city: string
  companyCode?: string
  accountingOnboardingSyncedPreOffer?: {
    syncedCompanyInfo?:
      | {
          propertyMessage: string
          propertyValue: string
        }[]
      | null

    syncedBankInfo?:
      | {
          propertyMessage: string
          propertyValue: string
        }[]
      | null

    businessInfo?:
      | {
          propertyMessage: string
          propertyValue: string
        }[]
      | null
  } | null
}
